import styled from 'styled-components';

/**
 * Text available to assistive technology but never painted. The only way to give the design-system
 * `Button` a real accessible name when it must show no visible text: `Button` derives its own
 * `aria-label` from its children and applies that after whatever the caller passes in, so a
 * caller-supplied `aria-label` is silently discarded (confirmed by rendering the compiled component —
 * an icon-only `Button` reports its icon name as its accessible name, never a custom `aria-label`).
 * `aria-labelledby` outranks `aria-label` in the accessible-name algorithm, so pointing it at one of
 * these survives.
 *
 * Hiding has to be done by collapsing the box rather than with `display: none` or
 * `visibility: hidden`, both of which take the node out of the accessibility tree as well — an
 * `aria-labelledby` pointing at either would resolve to no name at all.
 */
export const NovaVisuallyHidden = styled.span`
	position: absolute;
	width: 1px;
	height: 1px;
	margin: -1px;
	padding: 0;
	overflow: hidden;
	clip: rect(0, 0, 0, 0);
	white-space: nowrap;
	border: 0;
`;
